import './App.css';
import Appoinment from './components/appointment';
import Media from './components/media';
import Qnext from './components/qnext';
import Qnow from './components/qnow';
import Logo from './components/้logo';
import { useEffect, useState } from "react";
import axios from "axios";
import Qrcode from './components/qrcode';
import Swal from "sweetalert2";
import Footer from './components/footer';

// function App() {

//   const [iftime, setIftime] = useState(new Date().toLocaleTimeString());

//   useEffect(()=>{
//     const timer = setInterval(()=>{
//       setIftime(new Date().toLocaleTimeString())
//     },60000)
//     return()=>clearInterval(timer)
//   },[])  


//   if(iftime < "15:15:00"){
//     return (
//       <div className="App">
//         <Logo/>
//         <div className='mediaday'>
//           <Media/>
//           <div>
//           <Qnow/>
//           </div>
//         </div>
//       </div>
//     );
//   }
//   else {
//     return (
//       <div className="App">
//         <Logo/>
//         <div className='mediaday'>
//           <Media/>
//           <div>
//           <Qnext/>
//           </div>
//         </div>
//       </div>
//     );
//   }

// }

// export default App;


function App() {

  useEffect(() => {
    const pass = sessionStorage.getItem("password");
    async function requiredpassword() {
      const { value: password } = await Swal.fire({
        title: 'กรุณาระบุรหัสผ่าน',
        input: 'password',
        inputPlaceholder: 'กรุณาระบุรหัสผ่าน',
        inputAttributes: {
          maxlength: 10,
          autocapitalize: 'off',
          autocorrect: 'off'
        }
      })

      if (password === "ttm11442") {
        Swal.fire({
          icon: "success",
          title: "ยินดีต้อนรับ",
          showConfirmButton: false,
          timer: 1500,
        }).then((result) => {
          sessionStorage.setItem('password', password);
        });
      }
      else {
        Swal.fire({
          icon: "warning",
          title: "รหัสผ่านไม่ถูกต้อง",
          showConfirmButton: false,
          timer: 1500,
        }).then((result) => {
          requiredpassword()
        });
      }
    }
    if (pass === "ttm11442") {
      Swal.fire({
        icon: "success",
        title: "ยินดีต้อนรับ",
        showConfirmButton: false,
        timer: 1500,
      })
    }
    else {
      requiredpassword()
    }
  }, [])

  return (
    <div>
      <div>
        <Appoinment />
        <Footer/>
      </div>
    </div>
  )

}

export default App;



